export interface WelcomeCouponData {
  id: number;
  couponCode: string;
  description: string;
  value?: number | null;
  redemptionFrom?: string | null;
  redemptionTo?: string | null;
  isValidForAllStores: boolean;
  offerTitle?: string;
  offerValue?: string;
};

export interface SelfRegisterRequestModel {
  FirstName: string;
  LastName: string;
  Gender?: string | null;
  Email: string;

  NationalIdNumber: string;
  StoreCode: string;
  MobilePhone: string;
  GroupId?: number;
  OverrideIdCreatorPlatformType?: number | null;

  Privacy1: boolean;
  Privacy2: boolean;
  Privacy3?: boolean | null;
  PrivacyPrintedOnDate?: string;

  UrlRegistrationSource: string;  
  FullUrlRegistrationSource?: string | null;
}

export interface RegisterUserAndCustomerRequestModel extends SelfRegisterRequestModel {

  SignInName: string;
  Password: string;

}



export enum SelfRegisterSecurityBehaviourEnum {
  MaxSecurity = 0,
  ViewCardOnly = 1,
  ViewAnUpdateMissingData = 2,
  ViewAnUpdateAllData = 3
}

export interface SelfRegisterCustomer {
  card?: string | null;
  email?: string | null;
}

export type SelfRegisterResponse =
  | {
      type: 'success';
      customer: SelfRegisterCustomer | null;
      welcomeCouponData?: WelcomeCouponData | null;
    }
  | {
      type: 'existsSameStore';
      message: string;
      customer: SelfRegisterCustomer | null;
      username: string;
    }
  | {
      type: 'existsOtherStore';
      message: string;
      customer: SelfRegisterCustomer | null;
      username: string;
    }
  | {
      type: 'error';
      message: string;
      status?: number;
      customer?: null;
    };    